// aptStore.js — Datenschicht für den Terminplan.
// LIVE: Supabase (public.apts, RLS) · DEMO: localStorage.
// Wie bei den anderen Stores wird die Liste in localStorage gespiegelt
// ("dida_apts"), damit die synchrone Rechenschicht (metrics.js) sie liest.
//
// IDs kommen vom Client (Date.now()) — dadurch bleiben ICS-Merge und
// bestehende Termin-Logik unverändert; die Tabelle upsertet auf id.
import { supabase } from "./supabase";
import { serverActive } from "./mode";

const CACHE_KEY = "dida_apts";

export const loadAptsCache = () => {
  try { const s = localStorage.getItem(CACHE_KEY); if (s) return JSON.parse(s); } catch {}
  return [];
};
const saveCache = (rows) => { try { localStorage.setItem(CACHE_KEY, JSON.stringify(rows)); } catch {} };

const fromDb = (r) => {
  const { cancel_reason, wait_since, ics_uid, created_at, updated_at, ...rest } = r;
  return { ...rest, cancelReason: cancel_reason || "", waitSince: wait_since ?? null, ...(ics_uid ? { icsUid: ics_uid } : {}) };
};
const COLS = ["id","date","time","dur","patient","dob","allergy","behandler","type","anliegen","status","src","kv","notes","room"];
const toDb = (a) => {
  const out = {};
  COLS.forEach(k => { if (a[k] !== undefined && a[k] !== null) out[k] = a[k]; });
  out.cancel_reason = a.cancelReason || "";
  out.wait_since = a.waitSince ?? null;
  out.ics_uid = a.icsUid || "";
  return out;
};

export async function listApts() {
  if (!serverActive()) { const rows = loadAptsCache(); saveCache(rows); return rows; }
  const { data, error } = await supabase.from("apts").select("*").order("id");
  if (error) throw error;
  const rows = data.map(fromDb);
  saveCache(rows);
  return rows;
}

export async function upsertApt(apt) {
  if (!serverActive()) {
    const rows = loadAptsCache();
    const i = rows.findIndex(x => x.id === apt.id);
    if (i >= 0) rows[i] = apt; else rows.push(apt);
    saveCache(rows);
    return rows;
  }
  const { error } = await supabase.from("apts").upsert(toDb(apt), { onConflict: "id" });
  if (error) throw error;
  return listApts();
}

export async function deleteApt(id) {
  if (!serverActive()) {
    const rows = loadAptsCache().filter(x => x.id !== id);
    saveCache(rows);
    return rows;
  }
  const { error } = await supabase.from("apts").delete().eq("id", id);
  if (error) throw error;
  return listApts();
}

// Vollständige Liste schreiben (ICS-Merge, Behandler-Normalisierung).
// Upsertet alle Zeilen — löscht nichts (die Aufrufer entfernen keine Termine).
export async function saveAllApts(rows) {
  if (!serverActive()) { saveCache(rows); return rows; }
  if (rows.length) {
    const { error } = await supabase.from("apts").upsert(rows.map(toDb), { onConflict: "id" });
    if (error) throw error;
  }
  return listApts();
}
